// extracted by mini-css-extract-plugin
module.exports = {"globalHeader":"blue__globalHeader--2lNGq"};
    if(module.hot) {
      // 1541451119090
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  